module.exports = __webpack_public_path__ + "static/img/cell.94917e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/cell.png
// module id = UTOc
// module chunks = 1